import Axios from 'axios';

import AuthClientUtils from '../utils/Auth/auth-client';

export default () => {
  let endpoint = `${process.env.REACT_APP_BACKEND_ENDPOINT}/api/v1`;
  if (process.env.REACT_APP_SERVICE_ENV === 'local') {
    endpoint = 'api/v1';
  }

  const get = async ({ path, query = {} }) => {
    const token = AuthClientUtils.getToken();
    const options = {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        method: 'GET',
      },
      params: query,
    };

    try {
      const result = await Axios.get(`${endpoint}/${path}`, options);
      return result.data;
    } catch (error) {
      const err = new Error(error.response.data.message);
      err.status = error.response.status;
      throw err;
    }
  };

  const post = async ({ path, body = {}, query = {} }) => {
    const token = AuthClientUtils.getToken();
    const options = {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        method: 'POST',
      },
      params: query,
    };

    try {
      const result = await Axios.post(`${endpoint}/${path}`, body, options);
      if (result.status === 401) throw new Error('Unauthorised');
      return result.data;
    } catch (error) {
      throw error;
    }
  };

  const patch = async ({ path, body = {} }) => {
    const token = AuthClientUtils.getToken();
    const options = {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        method: 'PATCH',
      },
    };

    try {
      const result = await Axios.patch(`${endpoint}/${path}`, body, options);
      if (result.status === 401) throw new Error('Unauthorised');
      return result.data;
    } catch (error) {
      throw error;
    }
  };

  return {
    get,
    post,
    patch,
  };
};
